import * as React from 'react';
import { Box, Typography, Grid, Stack } from '@mui/material';

// チャットメッセージの型定義
export interface IChat {
    from: string;    // 送信者
    text: string;    // メッセージ内容
    date: string;    // 日付
    time: string;    // 時刻
    read: boolean;   // 既読状態
} 

/** chat 吹き出し */
const ChatBubble = ({chat, user}:{chat: IChat, user: string}) => {
  // 自分のメッセージかどうかを判定
  const isMe = chat.from === user;
  // 背景色を設定（自分のメッセージは青系、相手のメッセージはグレー）
  const bg = isMe ? "#BBBBEE" : "#EEEEEE";
  // メッセージの配置を設定（自分のメッセージは右、相手のメッセージは左）
  const align = isMe ? "end" : "start"

  // 時刻と既読表示のコンポーネント
  const TimeUnit = () => (
    <Box 
        flexDirection='column' 
        textAlign='center' 
        paddingX='10px'
    >
        {/* 日付と時刻の表示 */}
        <Box>
            <Typography variant='caption' margin={0}>
                {chat.date} {chat.time}
            </Typography>
        </Box>
        {/* 自分のメッセージで既読の場合に表示 */}
        {chat.read && isMe && (
            <Typography variant='caption'>
                既読
            </Typography>
        )}
    </Box>
  )

  return (
    // メッセージ全体のコンテナ
    <Stack
        flexDirection='row' 
        justifyContent={align}
        spacing={1}
        paddingX='10px'
        paddingY='5px'
    >
        {/* 自分のメッセージの場合、時刻を左に表示 */}
        {isMe && <TimeUnit />}
        <Box>
            {/* メッセージ本文 */}
            <Box sx={{
                backgroundColor: bg,
                padding: '10px',
                borderRadius: '10px',
                whiteSpace: 'pre-line'
                }}>
                {chat.text}
            </Box>
            {/* 送信者名 */}
            <Box textAlign={align} paddingX='10px'>
                <Typography variant='caption'>
                    {chat.from}
                </Typography>
            </Box>
        </Box>
        {/* 相手のメッセージの場合、時刻を右に表示 */}
        {!isMe && <TimeUnit />}
    </Stack>
  );
}

export default ChatBubble;